import React from "react";
const LTRIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "24px", height: "26px", viewBox: "0 0 24 26", ...props }, /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-58.000000, -583.000000)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(50.000000, 576.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: "0", y: "0", width: "40", height: "40" }), /* @__PURE__ */ React.createElement("g", { transform: "translate(8.000000, 7.000000)", fill: "currentColor" }, /* @__PURE__ */ React.createElement(
  "polygon",
  {
    transform: "translate(0.857143, 12.857143) scale(-1, 1) translate(-0.857143, -12.857143) ",
    points: "0 25.7142857 1.07142857 25.7142857 1.07142857 0 0 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M5.78571429,10.7142857 L5.78571429,3.42857143 L18.6428571,3.42857143 L18.6428571,10.7142857 L5.78571429,10.7142857 Z M17.6256379,9.72873086 L17.6256379,4.41412629 L6.80293355,4.41412629 L6.80293355,9.72873086 L17.6256379,9.72873086 Z",
    transform: "translate(12.214286, 7.071429) scale(-1, 1) translate(-12.214286, -7.071429) "
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M5.78571429,22.2857143 L24,22.2857143 L24,15 L5.78571429,15 L5.78571429,22.2857143 Z M6.81172341,15.9145094 L23.0499545,15.9145094 L23.0519536,21.3693648 L6.81372245,21.3693648 L6.81172341,15.9145094 Z",
    transform: "translate(14.892857, 18.642857) scale(-1, 1) translate(-14.892857, -18.642857) "
  }
))))))));
var LTRIcon_default = LTRIcon;
export {
  LTRIcon_default as default
};
//# sourceMappingURL=LTRIcon.js.map
